import Page from "../../components/Page";

export default function Contact() {
  return <Page title="Contact">Test </Page>;
}
